<section class="landing-main-surface">
  <div class="hero-section-main site-content-container">
    <!-- <section class="hero-section">
    <div class="hero-overlay"></div>

    <div class="hero-content">
      <span class="hero-eyebrow">
        CONNECTING ELECTEDS, CANDIDATES, ORGS, AND CONSTITUENTS
      </span>

      <h1 class="hero-title">
        Virtual Town Halls,<br />
        Community Discussions
      </h1>

      <p class="hero-subtitle">
        No bots or fake accounts allowed to comment
      </p>

      <button class="hero-btn">
        Get Started
        <span class="arrow">→</span>
      </button>
    </div>
  </section> -->
    <section class="hero-section">
      <!-- Background Video -->
      <video
        #heroVideo
        class="hero-video"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
      >
        <source
          src="https://keekudiag.blob.core.windows.net/profileimagedev/lender-page-video.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <!-- Overlay -->
      <div class="hero-overlay"></div>

      <!-- Content -->
      <div class="container h-100">
        <div
          class="row h-100 align-items-center justify-content-center text-center"
        >
          <div class="col-lg-9 col-md-10">
            <p class="hero-top-text font-20 fw-400 text-white">
              CONNECTING ELECTEDS, CANDIDATES, ORGS, AND CONSTITUENTS
            </p>

            <h1 class="hero-title fw-700 text-white my-3">
              Virtual Town Halls, Community Discussions
            </h1>

            <p class="hero-subtitle font-20 fw-400 text-white">
              No bots or fake accounts allowed to comment
            </p>

            <a routerLink="/signup" class="btn hero-btn text-white">
              Get Started
              <app-icon
                name="chevron-right"
                class="cx-icon--xs ml-1"
                aria-hidden="true"
              ></app-icon>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!-- Temporarily hidden until the dynamic homepage event banner is implemented.
<section
  class="event-announcement landing-main-surface pb-5"
  aria-labelledby="featured-event-title"
>
  <div class="hero-section-main site-content-container">
    <div class="event-card-container">
      <div class="row m-0">
        <div class="event-image-column col-lg-5 p-0">
          <img
            src="../../../assets/images/friends-of-normie-rescue.svg"
            class="event-image img-fluid"
            alt="Friends of Normie Rescue and Puppy Kitty NYC"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div
          class="col-lg-7 event-content-box d-flex flex-column justify-content-center text-center"
        >
          <div class="mb-4">
            <span class="upcoming-badge">• UPCOMING LIVE EVENT</span>
          </div>
          <h2
            id="featured-event-title"
            class="event-title event-title--featured fw-700 mb-3"
          >
            Friends of Normie and Puppy Kitty NYC: A Conversation with Ladan
            Davia and Meagan Licari
          </h2>

          <p class="event-date-time fw-600 mb-4">
            <app-icon
              name="calendar-days"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            September 14 | 10 AM PST / 1 PM EST
          </p>

          <p class="event-description mb-3">
            Join Ladan Davia of Friends of Normie Rescue and Meagan Licari of
            Puppy Kitty NYC for a conversation about animal rescue, building
            communities around a cause, and what each of us can do to make a
            difference.
          </p>
          <p class="event-description mb-3">
            We’ll talk about the realities of rescue, what they’ve learned along
            the way, how you can help—and, of course, cats!
          </p>
          <p class="event-description fw-600 mb-4">
            Don’t miss your chance to participate in the conversation!
          </p>

          <div class="d-flex flex-column align-items-center">
            <button
              class="btn btn-black event-btn mb-3 d-flex align-items-center justify-content-start pl-4"
              [routerLink]="['/signup']"
              [queryParams]="{ returnUrl: virtualEventReturnUrl }"
            >
              <div class="btn-icon mr-3">
                <app-icon
                  name="user-plus"
                  class="cx-icon--md"
                  aria-hidden="true"
                ></app-icon>
              </div>
              <div class="text-left">
                <p class="mb-0 font-18 fw-600">New? Sign Up & RSVP</p>
                <p class="mb-0 font-12 opacity-75">
                  Create and verify your account to join
                </p>
              </div>
            </button>
            <button
              class="btn btn-outline-black event-btn d-flex align-items-center justify-content-start pl-4"
              [routerLink]="['/login']"
              [queryParams]="{ returnUrl: virtualEventReturnUrl }"
            >
              <div class="btn-icon mr-3">
                <app-icon
                  name="log-in"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon>
              </div>
              <div class="text-left">
                <p class="mb-0 font-18 fw-600">Member? Log In & RSVP</p>
                <p class="mb-0 font-12 opacity-75">
                  Go straight to the event page
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
-->

<section class="landing-main-surface">
  <div class="container">
    <div class="townhall-section">
      <!-- Heading -->
      <div class="text-center mb-5">
        <div
          class="d-inline-flex align-items-center mb-3 flex-sm-row flex-column justify-content-center"
        >
          <p class="fw-600 town-hall-sec-title">A Message from our Founder</p>
        </div>
        <p class="font-18 fw-400">A vision to make democracy better</p>
      </div>

      <!-- Video -->
      <div class="row justify-content-center">
        <div class="col-lg-9 col-md-10 col-12">
          <div
            class="embed-responsive embed-responsive-16by9 mb-4 position-relative"
            style="border-radius: 12px; overflow: hidden; background: #000"
          >
            <video
              #founderVideo
              poster="../../../assets/images/thumnain-image.jpg"
              preload="metadata"
              class="embed-responsive-item w-100 h-100 cursor-pointer"
              style="object-fit: cover"
              (click)="toggleVideo()"
              (pause)="isVideoPlaying = false"
              (play)="isVideoPlaying = true"
              (ended)="onVideoEnded()"
            >
              <source
                src="https://class-media.s3.us-west-2.amazonaws.com/CitizeX+Horizontal.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <div
              *ngIf="!isVideoPlaying"
              class="position-absolute d-flex align-items-center justify-content-center w-100 h-100"
              style="top: 0; left: 0; pointer-events: none"
            >
              <button
                type="button"
                class="btn btn-dark rounded-circle d-flex align-items-center justify-content-center shadow"
                style="
                  width: 70px;
                  height: 70px;
                  opacity: 0.85;
                  pointer-events: auto;
                "
                (click)="toggleVideo()"
                aria-label="Play founder's message"
              >
                <app-icon
                  name="play"
                  class="founder-video__play-icon"
                  aria-hidden="true"
                ></app-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="testimonial-section" id="testimonial-section">
      <div>
        <!-- Heading -->
        <div class="text-center mb-5">
          <p class="testimonial-section-title">
            What People Are Saying About CitizeX
          </p>
        </div>

        <!-- Cards -->
        <div class="testimonial-grid">
          <!-- Card 1 -->
          <div class="card-1 testimonial-card-1">
            <div class="testimonial-card">
              <div class="col-12 px-0">
                <img src="../../../assets/images/lander-sec3-img1.svg" />
              </div>
              <div class="testimonial-card-padding">
                <p class="testimonial-text">
                  "This has the potential to fundamentally change how elected
                  officials communicate with their constituents. One of the most
                  important parts of serving in public office is hearing
                  directly from the people you represent. Too often, that
                  connection gets lost in the noise of today's existing
                  platforms. CitizeX has created a space where constituents can
                  engage in real conversations, ensuring that policy feedback,
                  questions and ideas actually come from the communities we
                  serve."
                </p>

                <div class="d-sm-flex align-items-center mt-3">
                  <div class="avatar card1-avatar">P</div>
                  <p class="user-name mb-0 fw-600 mt-sm-0 mt-2">
                    Former US Congressman, Erik Paulsen
                  </p>
                  <img
                    src="../../../assets/images/lander-sec3-img4.svg"
                    class="ml-auto"
                    height="80"
                    width="80"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="card-2 testimonial-card-2">
            <div class="testimonial-card">
              <div class="col-12 px-0">
                <img src="../../../assets/images/lander-sec3-img3.svg" />
              </div>
              <div class="testimonial-card-padding">
                <p class="testimonial-text">
                  "Having served in public life for 40 years, it was always a
                  challenge to reach the people I cared about, thought about,
                  and worked for. CitizeX gives current elected officials a safe
                  space to talk to their constituents. And it gives their
                  constituents a safe space to talk directly to their elected
                  officials. I think it's a game changer."
                </p>

                <div
                  class="d-sm-flex align-items-center testimonial-card2-avatar"
                >
                  <div class="avatar card2-avatar">B</div>
                  <div class="user-info">
                    <p class="mb-0 fw-600 mt-sm-0 mt-2">
                      Former US Senator, Barbara Boxer
                    </p>
                    <span class="user-underline"></span>
                  </div>
                  <img
                    src="../../../assets/images/lander-sec3-img5.svg"
                    class="ml-auto"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="card-3 testimonial-card-3">
            <div class="testimonial-card">
              <div class="col-12 px-0">
                <img
                  src="../../../assets/images/lander-sec3-img6.svg"
                  class="testimonial-card-3-img"
                />
              </div>
              <div class="testimonial-card-padding">
                <p class="testimonial-text">
                  "CitzeX is the perfect platform for elected officials and
                  candidates to hold townhall forums with minimal interference
                  from wackadoos and without big tech monitoring the dialogue."
                </p>

                <div
                  class="d-sm-flex align-items-center testimonial-card3-avatar"
                >
                  <div class="avatar card3-avatar">
                    <p>B</p>
                  </div>
                  <div class="user-info">
                    <p class="mb-0 fw-600 mt-sm-0 mt-2">
                      Former US Congressman, Ken Buck
                    </p>
                    <span class="user-underline-card3"></span>
                  </div>
                  <img
                    src="../../../assets/images/lander-sec3-img8.svg"
                    class="ml-auto"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Card 4 -->
          <div class="card-4 testimonial-card">
            <div class="testimonial-card-4-padding">
              <p class="testimonial-text">
                "Throughout my career managing campaigns at every level, I've
                seen how easily meaningful dialogue between leaders and the
                people they serve can be drowned out by outside noise and
                digital agitators. The future of civic engagement depends on our
                ability to declutter that space and return to authentic,
                human-centered conversation. By prioritizing verified users,
                CitizeX provides the safe and informative environment elected
                officials and constituents need to move past the spam and focus
                on real policies effecting our communities."
              </p>
              <div
                class="d-sm-flex align-items-center testimonial-card4-avatar"
              >
                <div class="avatar card4-avatar">
                  <p>S</p>
                </div>
                <div class="user-info">
                  <p
                    class="mb-0 col-lg-9 col-sm-11 col-12 px-0 fw-600 mt-sm-0 mt-2"
                  >
                    Greg Schultz, former Biden 2020 Primary Campaign Manager
                  </p>
                  <span class="user-underline-card4"></span>
                </div>
                <img
                  src="../../../assets/images/lander-sec3-img7.svg"
                  class="ml-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="cta-card-section py-5">
      <div class="row">
        <!-- Card 1 -->
        <div class="col-lg-6 mb-4 d-flex">
          <div class="cta-card w-100">
            <div class="cta-img cta-img-1"></div>

            <div class="cta-body">
              <p class="cta-title font-24 fw-600 pb-3 mb-3">
                For Elected Officials
              </p>
              <p class="cta-subtitle font-16 fw-400">
                Claim your official page or create one today to:
              </p>
              <ul class="cta-list">
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Host virtual town halls
                </li>
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Share announcements and updates
                </li>
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Engage with your verified constituents directly
                </li>
              </ul>

              <button
                class="btn btn-black cta-btn font-16 fw-600"
                routerLink="/signup"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
        <!-- Card 2 -->
        <div class="col-lg-6 mb-4 d-flex">
          <div class="cta-card w-100">
            <div class="cta-img cta-img-2"></div>
            <div class="cta-body">
              <p class="cta-title font-24 fw-600 pb-3 mb-3">
                For General Public
              </p>
              <p class="cta-subtitle font-16 fw-400">
                Sign up in a few minutes to:
              </p>
              <ul class="cta-list">
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Join conversations and polls
                </li>
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Attend public and constituent-only virtual town halls
                </li>
                <li class="d-flex">
                  <span
                    class="tick-mark d-flex justify-content-center align-items-center"
                    ><app-icon
                      name="circle-check"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon></span
                  >Find and engage directly with your representatives
                </li>
              </ul>

              <button
                class="btn btn-black cta-btn font-16 fw-600"
                routerLink="/signup"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mb-4 d-flex">
          <div class="request-demo-card text-center">
            <p class="font-24 fw-600 mb-4">
              Interested in using Citizex for your organization?
            </p>
            <button
              class="btn btn-outline-black font-16 fw-600"
              routerLink="/request-demo"
            >
              Request a Demo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="landing-main-surface how-it-works-section pb-5">
  <div class="container">
    <!-- Heading -->
    <div class="text-center mb-5">
      <p class="fw-600 how-it-works-section-title">How it works?</p>
      <p class="fw-400 font-16 mt-3">
        <span class="fw-700">Citizex</span> is dedicated to strengthening civic
        engagement by enabling real, verified conversations between elected
        leaders, candidates, organizations, and constituents through virtual
        town halls and community discussions, with no bots or fake accounts
        allowed.
      </p>
    </div>

    <!-- Cards -->
    <div class="row">
      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="how-work-card h-100">
          <p class="font-16 fw-600 how-work-card-title pb-3">
            Create and Share Conversations
          </p>
          <ul class="check-list">
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
                ><app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon></span
              >Publish posts, announcements, and polls in one place
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
                ><app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon></span
              >Spark meaningful discussions around community topics
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
                ><app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon></span
              >Keep conversations organized and easy to follow
            </li>
          </ul>

          <div class="conversion-image">
            <img
              src="../../../assets/images/conversion-image1.svg"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="how-work-card h-100">
          <p class="font-16 fw-600 how-work-card-title pb-3">
            Host and Attend Virtual Town Halls
          </p>
          <ul class="check-list">
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >Host live virtual town halls with your community
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >Attend public or constituent-only events
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >Engage in real-time discussions from anywhere
            </li>
          </ul>

          <div class="conversion-image">
            <img
              src="../../../assets/images/conversion-image2.svg"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-lg-4 col-md-12 mb-4">
        <div class="how-work-card h-100">
          <p class="font-16 fw-600 how-work-card-title pb-3">
            Verified-Only Engagement
          </p>
          <ul class="check-list">
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >Only verified accounts can post, reply, and engage
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >Identity verification powered by Didit
            </li>
            <li class="d-flex">
              <span
                class="tick-mark d-flex justify-content-center align-items-center"
              >
                <app-icon
                  name="circle-check"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon> </span
              >No bots or fake accounts - just real, trusted conversations
            </li>
          </ul>

          <div class="conversion-image">
            <img
              src="https://keekudiag.blob.core.windows.net/profileimagedev/conversion-image3.svg"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="landing-main-surface verification-section pb-5">
  <div class="container">
    <!-- TITLE -->
    <div class="text-center mb-5">
      <p class="verification-section-title fw-600">
        Verified. Secure. Private.
      </p>
      <p class="font-16 fw-400 mt-1">
        CitizeX uses secure identity verification to ensure authenticity, while
        keeping personal information encrypted and protected.
      </p>
    </div>

    <!-- CARD CONTAINER -->
    <div class="carousel-container">
      <!-- SLIDER 1 -->
      <div class="carousel-item-custom" [class.active]="activeSlide === 0">
        <div class="row">
          <div class="col-lg-6 col-md-7">
            <div
              class="content-left"
              [class.enter-left]="slide1State === 'enter'"
              [class.exit-left]="slide1State === 'exit'"
            >
              <p class="font-24 fw-700 mb-3">Confirm It’s Really You</p>
              <p class="font-16 fw-400 lh-1-7">
                We use an industry-leading identity verification provider,
                <a
                  class="btn-link-theme"
                  href="https://didit.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Didit</a
                >
                for a quick ID verification step to make sure real people are
                behind every post. Just a government-issued ID and a selfie is
                all it takes.
              </p>
            </div>
          </div>
          <div
            class="content-right col-lg-6 col-md-5 d-flex justify-content-end"
            [class.enter-right]="slide1State === 'enter'"
            [class.exit-right]="slide1State === 'exit'"
          >
            <img
              src="../../../assets/images/Didit-Logo.svg"
              class="img-fluid carousel-section-imge"
              alt="Didit"
            />
          </div>
        </div>
      </div>

      <!-- SLIDER 2 (NO animation) -->
      <div class="carousel-item-custom" [class.active]="activeSlide === 1">
        <div class="row">
          <div class="col-sm-5">
            <img
              src="../../../assets/images/carousel-section-img2.svg"
              class="img-fluid"
              alt="ID security"
            />
          </div>
          <div class="col-sm-7">
            <p class="font-24 fw-700 mb-3">Your Information Stays Safe</p>
            <p class="font-16 fw-400 lh-1-7">
              Your information is encrypted, private, and protected. Your ID is
              used only to confirm your identity and match you with the right
              representatives. Learn more about their data practices here:
            </p>
            <p class="mb-0">
              <a
                href="https://didit.me/terms/privacy-policy/"
                class="btn btn-link-theme btn-link p-0"
              >
                Didit's Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- DOT INDICATORS (optional but Figma-like) -->
    <div class="slider-dots mt-4">
      <span class="dot" [class.active]="activeSlide === 0"></span>
      <span class="dot" [class.active]="activeSlide === 1"></span>
    </div>
  </div>
</section>

<section class="landing-main-surface get-started-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 text-center">
        <p class="get-title fw-600 mb-2">Get Started</p>
        <p class="font-20 fw-400 mb-3">Join the conversation</p>
        <div class="btn-group-custom">
          <button class="btn btn-black font-16 fw-600" routerLink="/signup">
            I'm an Elected Official
          </button>
          <button
            class="btn btn-outline-black font-16 fw-600"
            routerLink="/signup"
          >
            I'm a Constituent
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
